// extracted by mini-css-extract-plugin
export default {"buttons":"KD3rz","fullWidth":"ywEdk"};